import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { CommonService } from '../../services/common.service';
import { GetinfoService } from '../../services/getinfo.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent { 

  loginInfo: any = {
    userid: '',
    userpw: ''
  }

  constructor(
    private router: Router,
    public commonService: CommonService,
    public getinfoService: GetinfoService
  ) { }

  loginproc() {

    if(this.loginInfo.userid == '') {
      // console.log(this.loginInfo.userid);
      this.commonService.danger('아이디를 입력해주세요');
      return;
    }
    
    if(this.loginInfo.userpw == '') {
      this.commonService.danger('비밀번호를 입력해주세요');
      return;
    }

    this.getinfoService.sendNoneAuthPost("/loginproc",this.loginInfo).then((data) => {
      let res: any = data;
      // console.log(data);
      if(res.code == "success") {
        this.commonService.success(res.msg);
        localStorage.setItem('myinfo',JSON.stringify(res.cominfo));
        localStorage.setItem('userToken',JSON.stringify(res.token));
        window.location.href = "index.html";
      }
      else {
        this.commonService.danger(res.msg);
      }
    });


  }

  findID() {

    this.commonService.confirm({
      title: '확인', 
      content: '파트너시스템 아이디는 SDN > 마이 > 파트너시스템에서 확인할 수 있습니다.',
      cancelTitle: '취소',
      confirmTitle: '바로가기'
    }).then((ok:any) => {
      if(ok) {
        this.commonService.openBrowser('https://www.sdnetworks.kr/mysd/partner')
      }
    });

  }

}
